// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cart .cart-item .dropdown-toggle{background-color:transparent;border-color:transparent}#cart .cart-item.bg-primary .dropdown-toggle{color:#fff}#cart .cart-item.bg-light .dropdown-toggle{color:#000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
